import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  deletedContactInfobox: 'This Contact has been deleted.',
  linkInvoiceTitle: 'Link Invoice to Contact',
  linkInvoiceBody:
    'To see Contact details here, the Invoice must have an existing Person or Business populated in the Customer Section.',
  linkInvoiceButton: 'Edit Invoice',
})
